import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { SharedService, Status } from '.././shared/shared.service';
import { BaseComponent } from '.././shared/base.component';
import { Message, ConfirmationService } from 'primeng/primeng';
import { PagerList, GlobalInfo, FPMessage, Severities, Country, RoleAccess, PageKey } from '.././shared/shared.model';
import { TranslateService } from '@ngx-translate/core';
import { VideoChatService } from '../dispatch/video-chat/video-chat.service';
import * as _ from 'lodash';
declare var $: any;
import * as moment from 'moment';
import { FPTextChatService } from './fp-textchat.service';
import { User, UserLookupFilter, ShowPageEnum, ThumbnailImage, ThumbnailInput } from './fp-textchat.model';
import { FPDataPassingService } from './fp-data-passing.service';
import { CapitalizeFirstPipe } from '../shared/pipes/custom-pipes.pipe';

@Component({
    selector: 'fp-textchat-popup',
    templateUrl: 'fp-textchat-popup.component.html',
    styleUrls: ['./fp-textchat-popup.css']
})
export class FPTextChatPopupComponent extends BaseComponent implements OnInit {

    @Output() done = new EventEmitter();
    @Output() chatCount = new EventEmitter();
    @Input() isShow: boolean;
    @Input() CompanyUniqueId: string;
    currentUserName: string = '';
    frmTextChat: FormGroup;
    conversationUsers: any;
    conversationList: any;
    selectedUser: any = {};
    showOnline: any;
    messageArray: any[] = [];
    public totalNotifcationCount: number = 0;
    currentUserID: string;
    chatUsers: any;
    showUsers: boolean = false;
    currentUser: User = new User();
    public rows: number;
    public page: number;
    public order: string;
    public sortby: string;
    public rowsperOptions: any;
    public getRows: number;
    filteroptionId: number = 1;
    stacked: boolean;
    togglelist: boolean = false;
    pageCount: number = 1;
    public filterdetails: UserLookupFilter;
    public usersval: User[] = [];
    public usersList: User[] = [];
    showPage: ShowPageEnum = 0;//0-RecentConvo,1-ConvoMessage,2-UsersList,3-CreateNewGroup,4-UserSettings,5-UserProfile
    gi: GlobalInfo;
    logedinUser: User = new User();
    img: ThumbnailImage[] = [];
    chatsearch: string = '';
    constructor(protected sharedService: SharedService, private route: ActivatedRoute, protected translate: TranslateService,
        private confirmationService: ConfirmationService, private formBuilder: FormBuilder, public chatProvider: FPTextChatService,
        public dataPassingService: FPDataPassingService, private location: Location, private videoChatService: VideoChatService) {
        super(sharedService, translate);
        this.gi = this.globalInfo();
    }
    ngOnInit() {
        this.onLoad();
    }
    ngOnChanges(changes) {
        if (this.isShow == true)
            this.onLoad();
    }
    onLoad() {
        debugger;
        this.currentUserID = this.globalInfo().Email;
        this.frmTextChat = this.formBuilder.group({
            message: ['']
        });
        if (this.filterdetails == null) {
            this.filterdetails = new UserLookupFilter();
        }
        this.rows = this.getRows;
        this.page = 0;
        this.order = "DisplayName";
        this.sortby = "Asc";
        this.chatProvider.companyUniqueId = this.CompanyUniqueId;

        this.chatProvider.startSubscribe();
        var org = {
            "org": {
                "name": this.globalInfo().CompanyCode,
                // "orgId": this.globalInfo().CompanyId
                "orgId": this.CompanyUniqueId
            }
        };
        this.chatProvider.registerOrg(org).then(t => {
        });
        this.chatProvider.actionCable.subscriptions.create('NotificationsChannel', {
            received: (message: any) => {

                this.dataPassingService.setMessage(message);
                this.dataPassingService.setNotificationIcon(true);
            }
        });
        this.chatProvider.actionCable.subscriptions.create('AppearancesChannel', {
            received: (message: any) => {
                this.dataPassingService.setApperance(message);
            }
        });
        this.loadAllUsers();
        //this.getConversationList();

        //this.totalNotifcationCount = _.sumBy(this.conversationList, 'new_messages');
        this.dataPassingService.getApperance().subscribe(data => {
            this.updateUserstatus(data);
        });
        this.dataPassingService.getMessage().subscribe(data => {
            debugger;
            let dataModal: any = data;
            if (dataModal.UserId == this.globalInfo().Email) {
                return;
            }
            var obj = {};
            if (!_.isEmpty(this.selectedUser) && dataModal.body) {
                if (this.selectedUser.conversation_id == dataModal.conversation_id || this.selectedUser.receiver_id == dataModal.UserId) {
                    if (!this.messageArray.find(x => x.posted_atstr == 'Today')) {
                        var output1 = { 'body': '', 'posted_at': moment().format(), UserId: this.currentUserID, type: 0, posted_atstr: 'Today' };
                        this.messageArray.push(output1);

                    }
                    if (!_.find(this.messageArray, dataModal)) {
                        dataModal.type = 1;
                        dataModal.posted_atstr = new Date(dataModal.posted_at).toDateString();
                        dataModal.posted_at = new Date(dataModal.posted_at);
                        this.messageArray.push(dataModal);
                        setTimeout(function () {
                            if ($('.onlinechat-messages'))
                                $('.onlinechat-messages').animate({ scrollTop: $('.onlinechat-messages')[0].scrollHeight }, "slow");
                        }, 300);
                    }
                    // Without badge count - Conversation Page
                    obj = { username: dataModal.username, body: dataModal.body, conversation_id: dataModal.conversation_id, receiver_id: dataModal.UserId, posted_at: dataModal.posted_at, new_messages: false };
                    this.updateConversationPage(obj)
                } else {
                    // With badge count - Conversation Page
                    obj = { username: dataModal.username, body: dataModal.body, conversation_id: dataModal.conversation_id, receiver_id: dataModal.UserId, posted_at: dataModal.posted_at, new_messages: true };
                    this.updateConversationPage(obj)
                }
            } else {
                if (dataModal.body) {
                    // With badge count - Conversation Page
                    obj = { username: dataModal.username, body: dataModal.body, conversation_id: dataModal.conversation_id, receiver_id: dataModal.UserId, posted_at: dataModal.posted_at, new_messages: true };
                    //this.updateConversationPage(obj)
                    this.getConversationList();
                }
            }
        });
    }

    newConvoOnClick() {
        this.filterdetails.SortBy = this.sortby;
        this.filterdetails.OrderBy = this.order;
        this.filterdetails.StartRecord = this.page;
        this.filterdetails.EndRecord = this.rows;
        this.filterdetails.CompanyID = this.globalInfo().CompanyId;
        this.filterdetails.LoginId = this.globalInfo().LoginId;
        this.filterdetails.MaxRoleGroup = this.globalInfo().MaxRoleGroup;
        this.filterdetails.VendorId = this.globalInfo().VendorId;
        this.videoChatService.getUsers(this.filterdetails.CompanyID, this.filterdetails.LoginId, 0, 0, this.filterdetails.StartRecord, this.filterdetails.EndRecord, this.filterdetails.SortBy, this.filterdetails.OrderBy).subscribe(resp => {
            this.showPage = 2;
            this.pageCount = resp.TotalRecord;
            var imput: ThumbnailInput[] = [];
            var userl = resp.UserListModel;
            userl.forEach(m => {
                if (m.PhotoPath)
                    imput.push({ LoginId: m.LoginId, fileName: m.PhotoPath, EmailId: m.Email });
                else
                    m.attachment = '';
            });
            this.videoChatService.getUserThumbnail(this.globalInfo().CompanyId, imput).subscribe(p => {
                p.forEach(b => {
                    var ind = userl.findIndex(fi => fi.LoginId == b.LoginId);
                    if (ind != -1) {
                        userl[ind].attachment = b.attachment;
                    }
                });
                this.img = p;
                this.usersList = userl;
                this.usersval = userl;
                this.logedinUser = this.usersList.find(f => f.LoginId == this.gi.LoginId);
            });
        });
    }
    loadAllUsers() {
        this.filterdetails.SortBy = this.sortby;
        this.filterdetails.OrderBy = this.order;
        this.filterdetails.StartRecord = this.page;
        this.filterdetails.EndRecord = this.rows;
        this.filterdetails.CompanyID = this.globalInfo().CompanyId;
        this.filterdetails.LoginId = this.globalInfo().LoginId;
        this.filterdetails.MaxRoleGroup = this.globalInfo().MaxRoleGroup;
        this.filterdetails.VendorId = this.globalInfo().VendorId;
        this.videoChatService.getUsers(this.filterdetails.CompanyID, this.filterdetails.LoginId, 0, 0, this.filterdetails.StartRecord, this.filterdetails.EndRecord, this.filterdetails.SortBy, this.filterdetails.OrderBy).subscribe(resp => {
            this.pageCount = resp.TotalRecord;
            var imput: ThumbnailInput[] = [];
            var userl = resp.UserListModel;
            userl.forEach(m => {
                if (m.PhotoPath)
                    imput.push({ LoginId: m.LoginId, fileName: m.PhotoPath, EmailId: m.Email });
                else
                    m.attachment = '';
            });
            this.videoChatService.getUserThumbnail(this.globalInfo().CompanyId, imput).subscribe(p => {
                p.forEach(b => {
                    var ind = userl.findIndex(fi => fi.LoginId == b.LoginId);
                    if (ind != -1) {
                        userl[ind].attachment = b.attachment;
                    }
                });
                this.img = p;
                this.usersList = userl;
                this.usersval = userl;
                this.logedinUser = this.usersList.find(f => f.LoginId == this.gi.LoginId);
                this.getConversationList();
            });
        });
    }
    closeUsers() {
        this.showUsers = false;
    }
    onUserListSearch(text: string) {
        this.usersval = this.usersList.filter(f => f.DisplayName.toLowerCase().startsWith(text.trim().toLowerCase()) == true || f.DisplayName.toLowerCase().endsWith(text.trim().toLowerCase()));
    }
    onConvoListSearch(text: string) {
        this.chatsearch = text;
        this.conversationUsers = this.conversationList.filter(f => f.username.toLowerCase().startsWith(text.trim().toLowerCase()) == true || f.username.toLowerCase().endsWith(text.trim().toLowerCase()));
    }
    openChatFromModel(user: User) {

        this.currentUser = user;
        this.showUsers = false;
        var studentRecord: any = _.find(this.conversationList, { 'receiver_id': (user.Email).toString() });

        if (studentRecord) {
            var data1 = {
                username: user.DisplayName,
                conversation_id: studentRecord ? studentRecord.conversation_id : '',
                receiver_id: user.Email,
                online: '',
                IsActive: user.IsActive
            }
            this.getConversationById(data1, 'chatUser');
        }
        else {
            var reg = {
                "user":
                {
                    "name": user.DisplayName.length >= 6 ? user.DisplayName : user.FirstName + " " + user.LastName,
                    "userid": user.Email,
                    "picture": "",
                    //"org_id": this.globalInfo().CompanyId
                    "org_id": this.CompanyUniqueId
                }
            };
            this.chatProvider.registerUser(reg).then(m => {
                // var data = { 'receiver_id': user.Email, 'personal_message': { 'body': 'Hi' } };
                this.chatProvider.getUsers().then(tn => {
                    var Tn: any = tn;
                    var ui = Tn.user.findIndex(fi => fi.email == user.Email);
                    var us = Tn.user[ui];
                    // this.chatProvider.createPost(data).then((result: any) => {

                    //     if (result.status_message == 'Success') {
                    //         this.frmTextChat.reset();
                    //         this.messageArray = [];
                    //         // if (this.messageArray.length == 0) {
                    //         var output = { 'body': data.personal_message.body, 'posted_at': moment().format(), UserId: this.currentUserID }
                    //         var data1 = {
                    //             username: user.DisplayName,
                    //             conversation_id: result.conversation_id,
                    //             receiver_id: user.Email,
                    //             online: ''
                    //         }
                    //         this.getConversationById(data1, 'ModelPopup');
                    //         this.updateNewUser(result.conversation_id, output);
                    //         // }
                    //     }
                    // });
                    var data1 = {
                        username: user.DisplayName,
                        conversation_id: '',
                        receiver_id: user.Email,
                        online: '',
                        IsActive: user.IsActive
                    }
                    debugger;
                    this.getConversationById(data1, 'ModelPopup');

                });

            });

        }
        // this.chatProvider.getUserStatus(user.email).then((result: any) => {
        //     if (result.status == 200) {
        //         var data = {
        //             username: user.name,
        //             conversation_id: studentRecord ? studentRecord.conversation_id : '',
        //             receiver_id: user.id,
        //             online: result.data.online
        //         }
        //         this.getConversationById(data, 'ModelPopup');
        //     } else if (result.status == 404) {
        //         // this.commonService.setNotificationMessage({ type: 'error', message: 'api', showAlert: true, timeout: 3000 });
        //         console.log('error:404')
        //         console.log(result)
        //     }
        //     else {
        //         // this.commonService.setNotificationMessage({ type: 'error', message: 'غير قادر على العثور على المستخدم', showAlert: true, timeout: 3000 });
        //         console.log('error')
        //         console.log(result)
        //     }
        // });
    }
    getConversationList() {
        debugger;
        this.chatProvider.getHomeConversations().then((result: any) => {
            if (result.data == undefined || result.data.length <= 0) {
                var reg = {
                    "user":
                    {
                        "name": this.globalInfo().DisplayName,
                        "userid": this.globalInfo().Email,
                        "picture": "",
                        //"org_id": this.globalInfo().CompanyId
                        "org_id": this.CompanyUniqueId
                    }
                };
                this.chatProvider.registerUser(reg).then(m => {

                });
            }
            else {
                result.data.map(x => {
                    // x.username = this.usersList.find(cl => cl.Email == x.receiver_id).DisplayName;
                    var uname = this.usersList.findIndex(cl => cl.Email.toLowerCase() == x.receiver_id.toLowerCase());
                    if (uname != -1) {
                        x.username = this.usersList[uname].DisplayName;
                    }
                    else
                        x.username = '';

                    var ind = this.img.findIndex(fi => fi.EmailId == x.receiver_id);
                    if (ind != -1) {
                        x.attachment = this.img[ind].attachment;
                    }
                    else
                        x.attachment = '';
                });
                this.conversationUsers = result.data.reverse();
                this.conversationList = result.data;
                this.conversationList.map(x=>x.IsActive = this.usersList.find(d => d.Email == x.receiver_id)?this.usersList.find(d => d.Email == x.receiver_id).IsActive:1);
            }
            this.totalNotifcationCount = _.sumBy(this.conversationList, 'new_messages');
            this.chatCount.emit(this.totalNotifcationCount);

        });
    }
    updateUserstatus(data) {
        let statusModal: any = data;
        if (!_.isEmpty(this.selectedUser) && (statusModal.online == true || statusModal.online == false)) {
            if (this.selectedUser.receiver_id == statusModal.UserId) {
                this.currentUser.online = data.online;
            }
        } else {
            if (statusModal.online == true || statusModal.online == false) {
                if (_.find(this.conversationList, { 'receiver_id': statusModal.UserId })) {
                    var index = _.findIndex(this.conversationList, { 'receiver_id': statusModal.UserId });
                    this.conversationList[index].online = data.online;
                }
            }
        }
        if (this.conversationList) {
            this.conversationUsers = this.conversationList.filter(f => f.username.toLowerCase().startsWith(this.chatsearch.trim().toLowerCase()) == true || f.username.toLowerCase().endsWith(this.chatsearch.trim().toLowerCase()));
        }
        //this.conversationUsers = this.conversationList.filter(f => 1 == 1);
    }
    updateConversationPage(obj) {
        debugger;
        if (_.find(this.conversationList, { 'conversation_id': obj.conversation_id })) {
            if (!_.find(this.conversationList, { 'posted_at': obj.posted_at })) {
                var index = _.findIndex(this.conversationList, { 'conversation_id': obj.conversation_id });
                this.conversationList[index].body = obj.body;
                this.conversationList[index].posted_at = obj.posted_at;
                if (obj.new_messages) {
                    this.conversationList[index].new_messages = this.conversationList[index].new_messages ? this.conversationUsers[index].new_messages + 1 : 1;
                    this.totalNotifcationCount = _.sumBy(this.conversationList, 'new_messages');
                    //this.conversationUsers = this.conversationUsers.sort((n1, n2) => n1.posted_at - n2.posted_at);
                    this.chatCount.emit(this.totalNotifcationCount);
                }
            }
        } else {
            // New Message from New user
            obj.new_messages = 1;
            this.conversationList.unshift(obj);
            this.totalNotifcationCount = _.sumBy(this.conversationList, 'new_messages');
            this.chatCount.emit(this.totalNotifcationCount);
        }
        if (this.conversationList)
            //this.conversationUsers = this.conversationList.filter(f => 1 == 1).filter(f => f.username.toLowerCase().startsWith(this.chatsearch.trim().toLowerCase()) == true || f.username.toLowerCase().endsWith(this.chatsearch.trim().toLowerCase()));
            this.conversationUsers = this.conversationList.filter(f => 1 == 1);

    }
    getConversationById(conversation, from1) {
        debugger;
        this.messageArray = [];
        // Clear Notification Count    
        this.totalNotifcationCount = this.totalNotifcationCount - parseInt(conversation.new_messages == undefined ? 0 : conversation.new_messages);
        this.chatCount.emit(this.totalNotifcationCount);
        
        conversation.new_messages = '';
        this.showOnline = conversation.online;
        // Get list of conversation Messages by conversation ID
        this.selectedUser = conversation;
        this.currentUser = this.usersList.find(d => d.Email.toLowerCase() == conversation.receiver_id.toLowerCase());
        this.userStatus();
        this.showPage = 1;
        if (conversation.conversation_id) {
            this.chatProvider.getConversationsHome(conversation.conversation_id).then((result: any) => {
                var source = result.data;
                source.map(c => {
                    c.posted_atstr = new Date(c.posted_at).toDateString();
                });
                var curr = '';
                source.forEach(c => {
                    if (curr != c.posted_atstr) {
                        var a = _.clone(c, true);
                        var b = _.clone(c, true);
                        curr = a.posted_atstr;
                        if (c.posted_atstr == new Date().toDateString())
                            a.posted_atstr = 'Today';
                        else
                            a.posted_atstr = a.posted_atstr.substring(3);
                        a.type = 0;
                        this.messageArray.push(a);
                        b.type = 1;
                        this.messageArray.push(b);
                    }
                    else {
                        c.type = 1;
                        this.messageArray.push(c);
                    }
                });
                // this.messageArray = result.data;
                setTimeout(function () {
                    if ($('.onlinechat-messages'))
                        $('.onlinechat-messages').animate({ scrollTop: $('.onlinechat-messages')[0].scrollHeight }, "slow");
                }, 300);
            });
        } else {
            this.messageArray = [];
        }
    }

    sendMessage(formData, dt) {
        if (formData.value.message) {
            if (this.selectedUser.IsActive == 1) {
                var data = { 'receiver_id': this.selectedUser.receiver_id, 'personal_message': { 'body': formData.value.message.trim() } }
                this.chatProvider.createPost(data).then((result: any) => {
                    if (result.status_message == 'Success') {
                        this.frmTextChat.reset();

                        if (this.messageArray && this.messageArray.length > 0) {
                            if (new Date(this.messageArray[this.messageArray.length - 1].posted_at).toDateString() == new Date().toDateString()) {
                                var output = { 'body': data.personal_message.body, 'posted_at': moment().format(), UserId: this.currentUserID, type: 1, posted_atstr: new Date().toDateString() };
                                this.messageArray.push(output);
                            }
                            else {
                                var output1 = { 'body': data.personal_message.body, 'posted_at': moment().format(), UserId: this.currentUserID, type: 0, posted_atstr: 'Today' };
                                this.messageArray.push(output1);
                                var output = { 'body': data.personal_message.body, 'posted_at': moment().format(), UserId: this.currentUserID, type: 1, posted_atstr: new Date().toDateString() };
                                this.messageArray.push(output);
                            }
                        }
                        else {
                            var output1 = { 'body': data.personal_message.body, 'posted_at': moment().format(), UserId: this.currentUserID, type: 0, posted_atstr: 'Today' };
                            this.messageArray.push(output1);
                            var output = { 'body': data.personal_message.body, 'posted_at': moment().format(), UserId: this.currentUserID, type: 1, posted_atstr: new Date().toDateString() };
                            this.messageArray.push(output);
                        }
                        setTimeout(function () {
                            if ($('.onlinechat-messages'))
                                $('.onlinechat-messages').animate({ scrollTop: $('.onlinechat-messages')[0].scrollHeight }, "slow");
                        }, 300);
                    }
                });
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[Severities.warn],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[Severities.success]),
                    detail: this.translate.instant('CHATMESSAGEINACTIVE')
                });
            }
        }
    }
    updateNewUser(conversation_id, messageData) {
        this.selectedUser.conversation_id = conversation_id;
        var ind = this.img.findIndex(fi => fi.EmailId == this.selectedUser.receiver_id);
        var att = '';
        if (ind != -1) {
            att = this.img[ind].attachment;
        }

        var obj = {
            username: this.selectedUser.username,
            body: messageData.body,
            posted_at: messageData.posted_at,
            conversation_id: this.selectedUser.conversation_id,
            receiver_id: this.selectedUser.receiver_id,
            online: this.selectedUser.online,
            attachment: att
        }
        this.conversationList.unshift(obj);
        if (this.conversationList)
            this.conversationUsers = this.conversationList.filter(f => 1 == 1);
    }
    leftPaneltoggle() {
        super.LeftPanelToggle();
    }
    toggled: boolean = false;
    handleSelection(event) {
        if (event.char == null || event.char == 'null') {
            return;
        }
        var val = this.frmTextChat.controls['message'].value + event.char;
        this.frmTextChat.controls['message'].setValue(val);
    }
    clearAllMessage() {
        this.chatProvider.clearAllMessage(this.selectedUser.conversation_id).then(m => {
            this.getConversationById(this.selectedUser, '');
        });
    }
    showPagezero() {
        this.currentUser = null;
        this.selectedUser = {};
        this.getConversationList();
        this.showPage = 0;
    }
    showPageFive() {
        this.userStatus();
        this.showPage = 5;
    }
    userStatus() {
        this.chatProvider.getUserStatus(this.currentUser.Email).then((result: any) => {
            if (result.status == 200) {
                this.currentUser.online = result.data.online;
            }
        });
    }
}
